import { Box, Button, Card, Flex, Heading, Text } from 'rebass';
import { useRouter } from 'next/router';
import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import styled from 'styled-components';

import { StoryContext } from '../../pages/story';
import FooterImg from './assets/footer';
import MemberAvatar from '../MemberAvatar';
import useEntity from '../hooks/useEntity';

const ListWrap = styled.section`
  ul {
    list-style: none;
    padding: 0;
  }
  span {
    font-weight: bold;
    color: #28b299;
  }
  li {
    line-height: 1.5;
    color: ${props => props.theme.colors.mutedText};
    text-align: left;
    font-family: ${props => props.theme.fonts.sans};
  }
`;

const CtaBody = ({ visibilityRef, ...props }) => {
  const { query } = useRouter();
  const id = useContext(StoryContext);
  const story = useEntity({ id, type: 'stories' });
  const member = useEntity(story.member);

  return (
    <Flex flexDirection="column" alignItems="center" {...props}>
      <MemberAvatar size={120} id={story.member.id} border />
      <Heading as="h1" fontFamily="brand" textAlign="center">
        Like the story?
        <br />
        Want to connect with {member['first-name']}?
      </Heading>

      <Button
        type="button"
        onClick={() => {
          window.location.href = `${process.env.appURL}/member/${member['share-id']}/story_share/${
            query.id
          }`;
        }}
        ref={visibilityRef}
        variant="primary"
        my="20px"
        px="20px"
        py="15px"
        css="cursor: pointer;"
      >
        Join LifeTales
      </Button>
      <Flex mb={4}>
        <Text>Already have an account?</Text>
        &nbsp;
        <Button
          type="button"
          onClick={() => {
            window.location.href = `${process.env.appURL}/member/${
              member['share-id']
            }/story_share/${query.id}`;
          }}
          ref={visibilityRef}
          variant="unset"
          css="color: #7a69bf; text-decoration: underline;"
        >
          Sign In
        </Button>
      </Flex>
      <Card
        border="2px solid"
        bg="white"
        borderRadius={8}
        borderColor="border"
        p={4}
        pb={80}
        style={{
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Heading fontFamily="brand">Why create an account?</Heading>
        <ListWrap>
          <ul>
            <li>
              <span>&#10003;</span> Like and comment on stories;
            </li>
            <li>
              <span>&#10003;</span> Share stories <strong>privately</strong>;
            </li>
            <li>
              <span>&#10003;</span> Access shared stories anytime;
            </li>
            <li>
              <span>&#10003;</span> Get notified when a new story is shared;
            </li>
            <li>
              <span>&#10003;</span> Create your own stories!
            </li>
          </ul>
        </ListWrap>
        <Box
          style={{
            position: 'absolute',
            bottom: 0,
            right: 0,
          }}
        >
          <FooterImg style={{ display: 'block' }} />
        </Box>
      </Card>
    </Flex>
  );
};

CtaBody.defaultProps = {
  visibilityRef: () => {},
};

CtaBody.propTypes = {
  visibilityRef: PropTypes.oneOfType([PropTypes.func, PropTypes.shape({})]),
};

export default CtaBody;
